var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 627,
    height: 629,
    viewBox: "0 0 627 629",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313.5 628.581C486.641 628.581 627 488.095 627 314.796C627 141.498 486.641 1.01172 313.5 1.01172C140.359 1.01172 0 141.498 0 314.796C0 488.095 140.359 628.581 313.5 628.581Z",
    fill: "#92D3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M313.5 628.581C486.641 628.581 627 488.095 627 314.796C627 141.498 486.641 1.01172 313.5 1.01172C140.359 1.01172 0 141.498 0 314.796C0 488.095 140.359 628.581 313.5 628.581Z",
    fill: "#92D3FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5069_21272",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 627,
    height: 628
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M313.5 627.569C486.641 627.569 627 487.083 627 313.785C627 140.486 486.641 0 313.5 0C140.359 0 0 140.486 0 313.785C0 487.083 140.359 627.569 313.5 627.569Z",
    fill: "#92D3FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5069_21272)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5069_21272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.919 957.559H450.503L488.777 503.351C492.212 462.67 460.11 427.744 419.254 427.744H175.146C134.312 427.744 102.209 462.67 105.645 503.351L143.919 957.559Z",
    fill: "#0F289D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.844 456.017H325.462C340.255 456.017 352.247 442.494 352.247 425.84V367.15C352.247 350.475 340.255 336.973 325.462 336.973H277.844C263.051 336.973 251.059 350.497 251.059 367.15V425.84C251.059 442.516 263.051 456.017 277.844 456.017Z",
    fill: "#FFB17D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.906 336.885C396.78 401.615 342.641 391.702 277.91 372.576C213.179 353.45 176.219 285.459 195.345 220.728C214.471 155.998 282.462 119.037 347.192 138.163C411.923 157.289 435.032 272.154 415.906 336.885Z",
    fill: "#FFB17D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.731 469.41L627.276 719.623L514.074 767.657L423.959 619.573L481.731 469.41Z",
    fill: "#0F289D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002 439.343C-35.6332 563.377 -68.1517 727.632 -68.1517 727.632C-77.0144 746.605 -70.1868 776.891 -50.295 783.435L227.6 922.152L266.29 856.678L71.726 708.528L214.667 554.448L207.249 428.204C207.249 428.204 128.36 420.764 107.002 439.343Z",
    fill: "#0F289D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.747 345.595C233.728 351.984 261.082 343.056 244.385 323.317C223.968 299.18 205.389 257.405 238.827 249.987C272.242 242.568 262.964 282.483 277.801 282.483C292.66 282.483 279.661 229.57 285.219 199.874C290.778 170.178 366.909 173.877 404.023 168.318C441.159 162.738 445.798 82.93 350.191 94.0685C285.788 101.574 238.805 120.985 197.971 182.258C167.05 228.585 182.193 304.739 226.747 345.595Z",
    fill: "#03073C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.915 346.469C347.915 346.469 348.374 354.719 368.31 356.995C368.31 356.995 385.029 358.899 386.079 350.102C386.057 350.102 371.111 341.064 347.915 346.469Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5069_21272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 699.257,
    height: 864.585,
    fill: "white",
    transform: "translate(-71.9812 92.9746)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarH);
export default __webpack_public_path__ + "static/media/avatar-h.fdd3bb6ca13ffa1cd7b8a13c453fae30.svg";
export { ForwardRef as ReactComponent };